<template>
  <div >
    <v-row align="center" justify="start" no-gutters class="img">
      <v-col  style="height:70%;position:relative" cols="12" xl="6" lg="6">
        <div class=" ml-4 mt-4 pa-5 animate__animated animate__fadeInLeft animate_slow" style="position:absolute;width:40vw;background-color:#ffffffcb;right:0;">
          <p class="text-h2 font-weight-bold animate__animated animate__fadeIn animate_slower " style="color:#286738">Do You Need Affordable Housing?</p>
          <br>
          <v-btn style="text-transform:none;" color="#286738" class="animate__animated animate__fadeIn animate_slower"  dark large to="/c/userdata">Try the App</v-btn>
      </div>
      </v-col>
      <v-col cols="12" xl="6" lg="6">
        <!-- <div class=" ml-4 mt-4 pa-5" style="position:absolute;min-height:35vh;width:40vw;background-color:#ffffffcb">
          <p class="text-h2 font-weight-bold black--text">Do You Need Affordable Housing?</p>
      </div> -->
      </v-col>
    </v-row>

    <section style="height:15vh" class="white">
      <v-container fluid class="ma-3">
        <v-row no-gutters justify="center" align="center" style="height:100%">
           <v-col cols="12" xl="4" lg="4">
            <v-row no-gutters align="center" justify="center" style="height:100%;width:100%">
               <router-link to="/" style="text-decoration:none;color:white">
          <p class=" mr-2 text-h5 font-weight-bold animate__animated animate__fadeIn animate_slow"><v-img width="70" src="../assets/housingmatchmark.png"></v-img></p>
        </router-link>
        
         <span class="vl"></span>
            </v-row>
          
           </v-col>
          
           <v-col cols="12" xl="6" lg="6">
           
          <p class=" black--text animate__animated animate__fadeIn animate_slow">Welcome to the Affordable Housing Match and Search Engine! Just enter in a State, County, household size and your annual Income to return a list of Affordable Housing offerings in your area!</p>
           </v-col>
           <v-col cols="12" xl="2" lg="2"></v-col>
         

        </v-row>
      </v-container>
    </section>
    
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: "Home",

  components: {

  },
  data(){
    return {
      row:""
    }
  },
  methods:{
    submitreq(){
      axios.post('https://housing-match-server.herokuapp.com/state2',{
        statcode:"GA"
      }).then(res=>{
        console.log(res.data)
        console.log(typeof res.data)
        this.$store.commit("setData",res.data)
        this.$router.push("/c/affordable-housing-locator")
        
      }).catch(err=>{
        console.log(err)
      })
    }
  }
};
</script>
<style>
.main-div{
  background-color: #67a69c;
  height: 100vh;
  color: #fffcfc;
  font-family: 'Ubuntu', sans-serif;
}
.img{
  background-image: url('../assets/nini.jpg');
  background-size: cover;
  height: 80vh;
  width: 100%;
}
.fb-btn.v-btn {
    border: thin solid #007bff;
    color:#ffffffcb
  }
  .vl {
  border-left: 4px solid #5BBA9F;
  height: 80px;

}
</style>
